export default {
  setProfile(state, profile) {
    state.profile = profile;
  },
  setAppVersion(state, version) {
    state.version = version;
  }
};
